import React from 'react'
import PropTypes from 'prop-types'
import theme from '../../../theme'
import Aux from '../../../hoc/Ax/Ax'
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

const styles = {
    root: {
        whiteSpace: 'pre-wrap',
        padding: '0 16px 21.5px 27px',
        marginTop: '-10px',
        paddingLeft: theme.spacing.unit * 2,
        width: theme.dimensions.SidebarWidth,
        maxWidth:420,
        overflow:'hidden',
        width:"85vw",
        zIndex:5000,
        display:"flex",
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing.unit * 2,
            width:"100vw",
        },
        [theme.breakpoints.down('xs')]: {
            padding: '15px 16px 21.5px 27px',
            width:"100vw",
        },
    },
    myStyle: {
        whiteSpace: 'pre-wrap',
        padding: '5px 5px 5px 5px',
        paddingLeft: theme.spacing.unit * 2,
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing.unit * 2,
        },
        [theme.breakpoints.down('xs')]: {
            padding: '5px 5px 5px 5px',
        },
    },
}

/**
 * component for sidebar
 * @param title
 * @param subtitle
 * @param divider
 * @param children
 * @param classes
 * @returns {*}
 */
const sidebarItem = ({ title, subtitle, divider, children, classes }) => (
    <Aux>
        <Box style={styles.root} sx={{display:"flex", flexDirection:"column"}}>
            { title && (
                <Typography variant="subtitle1" style={{ paddingBottom: 15 }}>{title}</Typography>
            )}
            { subtitle && (
                <Typography variant="caption">{subtitle}</Typography>
            )}
            <br></br>
            {children}
        </Box>
        {divider && (
            <Divider style={{marginBottom:30}}/>
        )}
    </Aux>
)

export const MySidebarItem = ({ title, subtitle, divider, children, classes }) => (
    <Aux>
        <Box style={styles.root} sx={{display:"flex", flexDirection:"column"}}>
            { title && (
                <Typography variant="subtitle1" style={{ paddingBottom: 15 }}>{title}</Typography>
            )}
            { subtitle && (
                <Typography variant="caption">{subtitle}</Typography>
            )}
            {children}
        </Box>
        {divider && (
            <Divider/>
        )}
    </Aux>
)

sidebarItem.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    subtitle: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    divider: PropTypes.bool,
}

sidebarItem.defaultProps = {
    title: false,
    subtitle: false,
    divider: false,
}

//const MySidebarItem = withStyles(styles)(mySidebarItem)

//export MySidebarItem

export default sidebarItem
